var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1GridSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,80c0-26.5-21.5-48-48-48H48C21.5,32,0,53.5,0,80v96c0,26.5,21.5,48,48,48h352c26.5,0,48-21.5,48-48v-96ZM448,336c0-26.5-21.5-48-48-48H48c-26.5,0-48,21.5-48,48v96c0,26.5,21.5,48,48,48h352c26.5,0,48-21.5,48-48v-96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1GridSolid);
export default __webpack_public_path__ + "static/media/1-grid-solid.e1de348b6813aeabae6f8a9424763c2d.svg";
export { ForwardRef as ReactComponent };